export const ShortcutKey = {
	Control: 'ctrl',
	Alt: 'alt',
	Shift: 'shift',
	Meta: 'meta',
} as const;
export type ShortcutKey = (typeof ShortcutKey)[keyof typeof ShortcutKey];

export const KeyboardKey = {
	A: 'a',
	B: 'b',
	C: 'c',
	D: 'd',
	E: 'e',
	F: 'f',
	G: 'g',
	H: 'h',
	I: 'i',
	J: 'j',
	K: 'k',
	L: 'l',
	M: 'm',
	N: 'n',
	O: 'o',
	P: 'p',
	Q: 'q',
	R: 'r',
	S: 's',
	T: 't',
	U: 'u',
	V: 'v',
	W: 'w',
	X: 'x',
	Y: 'y',
	Z: 'z',

	Delete: 'Delete',
	Escape: 'Escape',

	ArrowUp: 'ArrowUp',
	ArrowDown: 'ArrowDown',
	ArrowLeft: 'ArrowLeft',
	ArrowRight: 'ArrowRight',

	Home: 'Home',
	End: 'End',
	PageUp: 'PageUp',
	PageDown: 'PageDown',
	Enter: 'Enter',

	F1: 'F1',
	F2: 'F2',
	F3: 'F3',
	F4: 'F4',
	F5: 'F5',
	F6: 'F6',
	F7: 'F7',
	F8: 'F8',
	F9: 'F9',
	F10: 'F10',
	F11: 'F11',
	F12: 'F12',
} as const;
export type KeyboardKey = (typeof KeyboardKey)[keyof typeof KeyboardKey];
/* -------------------------------------------------------------------------------------------------------------- */
export const KeyboardKeyCode: Record<KeyboardKey, number> = {
	[KeyboardKey.A]: 65,
	[KeyboardKey.B]: 66,
	[KeyboardKey.C]: 67,
	[KeyboardKey.D]: 68,
	[KeyboardKey.E]: 69,
	[KeyboardKey.F]: 70,
	[KeyboardKey.G]: 71,
	[KeyboardKey.H]: 72,
	[KeyboardKey.I]: 73,
	[KeyboardKey.J]: 74,
	[KeyboardKey.K]: 75,
	[KeyboardKey.L]: 76,
	[KeyboardKey.M]: 77,
	[KeyboardKey.N]: 78,
	[KeyboardKey.O]: 79,
	[KeyboardKey.P]: 80,
	[KeyboardKey.Q]: 81,
	[KeyboardKey.R]: 82,
	[KeyboardKey.S]: 83,
	[KeyboardKey.T]: 84,
	[KeyboardKey.U]: 85,
	[KeyboardKey.V]: 86,
	[KeyboardKey.W]: 87,
	[KeyboardKey.X]: 88,
	[KeyboardKey.Y]: 89,
	[KeyboardKey.Z]: 90,

	[KeyboardKey.Delete]: 46,
	[KeyboardKey.Escape]: 27,

	[KeyboardKey.ArrowUp]: 38,
	[KeyboardKey.ArrowDown]: 40,
	[KeyboardKey.ArrowLeft]: 37,
	[KeyboardKey.ArrowRight]: 39,

	[KeyboardKey.Home]: 36,
	[KeyboardKey.End]: 35,
	[KeyboardKey.PageUp]: 33,
	[KeyboardKey.PageDown]: 34,
	[KeyboardKey.Enter]: 13,

	[KeyboardKey.F1]: 112,
	[KeyboardKey.F2]: 113,
	[KeyboardKey.F3]: 114,
	[KeyboardKey.F4]: 115,
	[KeyboardKey.F5]: 116,
	[KeyboardKey.F6]: 117,
	[KeyboardKey.F7]: 118,
	[KeyboardKey.F8]: 119,
	[KeyboardKey.F9]: 120,
	[KeyboardKey.F10]: 121,
	[KeyboardKey.F11]: 122,
	[KeyboardKey.F12]: 123,
} as const;
export type KeyboardKeyCode = (typeof KeyboardKeyCode)[keyof typeof KeyboardKeyCode];
